import { apiProductBackendBaseUrl } from '@/lib/constants';
import axios from 'axios';

const CombineAPi = {
  productionPost: async (endpoint, body, authToken) => {
    const config = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };

    const result = await axios.post(
      `${apiProductBackendBaseUrl}/${endpoint}`,
      body,
      config,
    );
    return result?.data;
  },
};

export default CombineAPi;
